<template>
  <form novalidate @submit.prevent="whenValid(onSubmit)">
    <h3 class="headline my-4 blue--text text--darken-4">
      How can we help you?
    </h3>
    <v-text-field
      v-model.trim="form.name"
      v-validate="'required|max:50|alpha_spaces'"
      :counter="50"
      :error-messages="errors.collect('name')"
      label="Name"
      data-vv-name="name"
      autofocus
      required
    >
    </v-text-field>
    <v-text-field
      v-model.trim="form.email"
      v-validate="'required|email'"
      :error-messages="errors.collect('email')"
      label="E-mail"
      type="email"
      data-vv-name="email"
      required
    >
    </v-text-field>
    <v-text-field
      v-model="form.phone"
      v-validate="'required'"
      :error-messages="errors.collect('phone')"
      label="Phone Number"
      mask="phone"
      data-vv-name="phone"
    ></v-text-field>
    <v-text-field
      v-model.trim="form.subject"
      v-validate="'required'"
      :error-messages="errors.collect('subject')"
      label="What can we help with?"
      data-vv-name="subject"
      required
    >
    </v-text-field>
    <v-textarea
      v-model.trim="form.message"
      v-validate="'required|min:3|max:250'"
      :counter="250"
      :error-messages="errors.collect('message')"
      auto-grow
      label="Message"
      data-vv-name="message"
      rows="1"
    ></v-textarea>
    <v-checkbox
      v-model="form.human"
      v-validate="'required'"
      :error-messages="errors.collect('human')"
      label="I am a real person"
      value="1"
      data-vv-name="human"
      type="checkbox"
      required
    >
    </v-checkbox>
    <v-layout row wrap>
      <v-flex class="text-xs-center mt-5">
        <v-btn
          :disabled="errors.any() || !isComplete"
          large
          color="success"
          type="submit"
        >
          submit
        </v-btn>
        <v-btn large @click="clear">
          clear
        </v-btn>
      </v-flex>
    </v-layout>
    <v-alert
      :value="contactError"
      color="error"
      icon="warning"
      outline
      class="mt-3"
    >
      {{ contactError }}
    </v-alert>
  </form>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import validate from '../mixins/validate';
import { contact } from '../api/contact';
import { lowercase } from '../utils/filters';

export default {
  name: 'GeneralContactForm',
  mixins: [validate],
  $_veeValidate: {
    validator: 'new',
  },
  metaInfo: {
    title: 'Contact Us',
  },
  data() {
    return {
      form: {
        name: '',
        email: lowercase(''),
        phone: '',
        subject: '',
        message: '',
        human: null,
      },
      error: null,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          phone: 'Phone Number',
          subject: 'Subject',
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'Name field may not be greater than 50 characters',
          },
          subject: {
            required: () => 'A subject line is required',
          },
          message: {
            required: () => 'Message can not be empty',
            min: 'A minimum of 3 characters are required',
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      contactError: 'contactError',
      user: 'user',
    }),
    isComplete() {
      return (
        this.form.name &&
        this.form.email &&
        this.form.phone &&
        this.form.subject &&
        this.form.message &&
        this.form.human
      );
    },
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    // validate() {
    //   this.$validator
    //     .validateAll()
    //     .then((result) => {
    //       if (result) {
    //         this.onSubmit()
    //       }
    //     })
    //     .catch((err) => console.error(err))
    // },
    onSubmit() {
      this.$store.dispatch('contact');
      contact('contact', this.$data.form)
        .then((res) => {
          this.$store.commit('contactSuccess', res);
          this.clear();
          this.contactSuccess();
        })
        .then(() => this.$router.push({ path: '/' }))
        .catch((error) => {
          this.$store.commit('contactFailed', { error });
          this.contactFailed();
        });
    },
    contactSuccess() {
      this.showSnackbar({
        text: 'You have successfully sent an email!',
        color: 'success',
        timeout: 3000,
      });
    },
    contactFailed() {
      this.showSnackbar({
        text: 'There were problems with your email message!',
        color: 'warning',
        timeout: 3000,
      });
    },
    clear() {
      this.form.name = '';
      this.form.email = '';
      this.form.phone = '';
      this.form.subject = '';
      this.form.message = '';
      this.form.human = false;
      this.$validator.reset();
    },
  },
};
</script>
